/**
 * dcent-policy-anchor — 개정 이력 페이지에서 해시로 지목된 아코디언을 펼친다.
 *
 * 왜 필요한가: 날짜별 약관 아카이브 페이지를 `-change` 페이지의 `#v-YYYYMMDD` ·
 * `#c-YYYYMMDD` 로 301 시켰다. 그 id 는 `<details>` **자신**에 있는데, 브라우저는
 * 해시가 가리키는 details 를 스크롤해 줄 뿐 열어 주지는 않는다(내부 요소를 가리킬 때
 * 자동으로 펼치는 동작은 최신 브라우저에만 있고, 여기는 details 자체가 대상이다).
 * 그래서 리디렉션으로 도착한 사람이 접힌 제목만 보게 된다 — 법적 본문이라 그러면 안 된다.
 *
 * 양 샵 byte-identical.
 */
(function () {
  function openHashTarget() {
    var hash = window.location.hash;
    if (!hash || hash.length < 2) return;

    var el = null;
    try {
      el = document.querySelector(hash);
    } catch (err) {
      return; // 해시가 셀렉터로 못 쓰이는 문자열이면 조용히 지나간다
    }
    if (!el) return;

    // 대상이 details 자신일 수도, 그 안의 요소일 수도 있다 — 조상까지 훑어 전부 편다.
    var node = el;
    while (node && node !== document.body) {
      if (node.tagName === "DETAILS" && !node.open) node.open = true;
      node = node.parentElement;
    }

    // 펼치면서 문서 높이가 바뀌므로 위치를 다시 맞춘다.
    el.scrollIntoView();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", openHashTarget);
  } else {
    openHashTarget();
  }
  window.addEventListener("hashchange", openHashTarget);
})();
